import { environment } from '@env/environment';

/** Key under which the originally requested URL is kept across the Entra redirect. */
export const MSAL_REDIRECT_URL_KEY = 'msal.redirect.url';

/** Buffer before the actual expiration at which the ID token is refreshed. */
export const TOKEN_EXPIRY_BUFFER_MS = 5 * 60 * 1000;

/** Backends that authorize on the Entra ID token instead of the access token. */
export const RIC_API_URLS = [environment.api.backend];
